import { Phone, MessageCircle } from "lucide-react";

export default function StickyMobileCTA() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-[#062133]/10 p-3 sm:hidden shadow-[0_-4px_20px_rgba(0,0,0,0.08)]" data-testid="sticky-mobile-cta">
      <div className="flex gap-3">
        <a
          href="tel:+41245391033"
          className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 bg-[#336DBF] text-white rounded-md font-semibold text-sm"
          data-testid="sticky-call-btn"
        >
          <Phone size={16} />
          Appeler
        </a>
        <a
          href="https://wa.me/41786202854"
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 bg-[#25D366] text-white rounded-md font-semibold text-sm"
          data-testid="sticky-whatsapp-btn"
        >
          <MessageCircle size={16} />
          WhatsApp
        </a>
      </div>
    </div>
  );
}
